/**
 * 首页
 */
import React from 'react';
import ReactDom from 'react-dom';
import {View, Text, ScrollView, Image, DeviceEventEmitter} from 'react-native';
// mobx
import {observer, inject} from 'mobx-react';
import {QProvider} from '../../models/mobxInject';
import RootStore from '../../models/index'

// 组件
import QDNavBar from '@qnpm/q-navbar';
import { Provider } from '@qnpm/q-portal';
import { QPopupLayerProvider } from '@qnpm/q-popup-layer';
import SearchBar from './components/searchBar';
import SearchBox from './components/searchBox';
import SearchBoxWrapper from './components/searchBoxWrapper';
import Tab from './components/tab';
import Filter from './components/filter';
import CardSectionList from './components/cardSectionList';
import SearchFilter from './components/searchFilter';
import SearchFilterModal from './components/searchFilterModal'
import DepCityList from './components/depCityList';
import ArrCityList from './components/arrCityList';
import AiHelper from './components/aiHelper';
import Loading from './components/loading/loading';
import GoTop from './components/goTop';
import Calendar from './components/calendar';
import {Events, RaiseFrom} from '../../components/ExposureContainer';

// 常量
import {NAVBAR_HEIGHT, NOTCH_PHONE, getScreenSize, clickable, scroll} from "../../common/utils";
import styles from './style';
import QImageSet from '../../assets/QImageSet';

import {setItem} from '../../common/StorageUtils';
import {getQueryParam} from "../../models/search/util";
import {isQunarApp, isWxApp} from "../../common/hysdkUtils/env";
import {checkLogin} from "../../common/hysdkUtils/user";

const FILTER_HEIGHT = 48;
Text.defaultProps = {
    accessible: true,
    allowFontScaling: false,
    ellipsizeMode: 'tail'
};

// 注入store
function injectStore(stores) {
    const {lowPriceDataStore, searchDataStore} = stores || {};
    const {
        fetchData,
        setAnchor,
        setTabFixed,
        successToast,
        loading,
        lowPriceDepCity,
        error,
        fixedSearchBoxVisible,
        setLowPriceDepCity
    } = lowPriceDataStore || {};

    const {
        fetchData: getFilterConfig,
        initCityList,
        locationHandler,
        userSelect,
        logData,
        isInter
    } = searchDataStore || {};

    return {
        error,
        setLowPriceDepCity,
        initCityList,
        fixedSearchBoxVisible,
        locationHandler,
        lowPriceDepCity,
        successToast,
        loading,
        fetchData,
        setAnchor,
        setTabFixed,
        getFilterConfig,
        userSelect,
        logData,
        isInter
    };
}

@inject(injectStore)
@observer
class homePage extends React.Component {
    constructor(props) {
        super(props);
        this.points = [];

        // 第一张cardList的top
        this.cardListY = 0;
        this.state = {};
        this.tabFixed = false;
        // 吸顶头部的宽度，包括状态栏 和 header
        this.tabFixTop = NAVBAR_HEIGHT;
        this.getAppInfoCount = 0;
        this.scrollStopTimer = null; // 滚动停止后显示小球的定时器
        global.__low_price_home = this;
        hysdk && hysdk.onHide(() => {
            this.onPageHide();
        });
    }

    async componentDidMount() {
        await this.init();
    }

    componentWillUnmount() {
        this.clearScrollTimers();
    }

    onPageHide() {
        if (hysdk && hysdk.sniff && hysdk.sniff.qunar) {
            hysdk && hysdk.event && hysdk.event.sendEvent && hysdk.event.sendEvent({
                name: 'flight-hyaihelper-stop',
                data: {
                    invokeSource: 'INNER_BARGAIN_FLIGHT_LOW_PRICE_LIST_BALL'
                },
                success: function () {},
                fail: function () {}
            });
        }
    }

    async init() {
        const interceptBack = getQueryParam('interceptBack');
        if (isQunarApp() && !checkLogin()) {
            hysdk.login({
                success: () => {
                    this.init();
                },
                fail: () => {
                    if (interceptBack !=='true') {
                        hysdk.closeWebView();
                    }
                }
            })
            return;
        }

        const appInfoTimer = window.setInterval(() => {
            this.getAppInfoCount = this.getAppInfoCount + 1;
            // window.preAirlinePromise里有getAppInfo逻辑
            if (window.preAirlinePromise || this.getAppInfoCount > 10) {
                clearInterval(appInfoTimer);

                this.props.fetchData('', '', true);
                this.props.getFilterConfig();
            }
        }, 200);


        if (getQueryParam('depCity')) {
            return;
        }

        const cat = getQueryParam('cat');
        GodEye.log({
            r: 'page_show_sources',
            cat
        });
    

        let location = await this.props.locationHandler;
        let cityName = location && location.cityName;

        if (cityName && cityName !== this.props.lowPriceDepCity) {
            this.props.setLowPriceDepCity(cityName);
            this.props.initCityList(cityName);
            setItem('curLocation', cityName);
        }
    }

    onTabPress = (anchor, type) => {
        if(!clickable('tab_press')) {
            return;
        }
        GodEye.log({
            r: 'tab_click',
            type: type,
            tab: anchor
        });

        this.forzenTab = true;

        // 页面滚动
        let y = this.getAnchorPosY(anchor);

        let node = ReactDom.findDOMNode(this.scrollRef);

        // 兼容低版本
        if(node.scrollTo) {
            scroll(node, y, ()=>{
                this.forzenTab = false;
            });
        } else {
            this.scrollRef.scrollTo(y);
            this.forzenTab = false;
        }



        // tab滚动并选中
        this.props.setAnchor(anchor);
        this.setTabFixed('', true)
    };


    getAnchorPosY(anchor) {
        let anchorList = this.points.filter(point => point.anchor === anchor) || [];

        if (anchorList[0]) {
            return anchorList[0].y + this.cardListY - this.tabFixTop - FILTER_HEIGHT
        }

        return 0
    }

    setLayout = (p) => {
        this.points = p;
    };

    onMomentumScrollEnd = () => {
        DeviceEventEmitter.emit(Events.RequireUpdate, {
            raiseFrom: RaiseFrom.FinalState
        });
    };

    setCardListY = (y) => {
        this.cardListY = y;
    };

    clearScrollTimers = () => {
        if (this.scrollStopTimer) {
            clearTimeout(this.scrollStopTimer);
            this.scrollStopTimer = null;
        }
    };

    hideAiHelperBall = () => {
        this.clearScrollTimers();
        if (this.aiHelperInstance && typeof this.aiHelperInstance.closeAiHelperBallAimation === 'function') {
            this.aiHelperInstance.closeAiHelperBallAimation();
        }
    };

    showAiHelperBall = () => {
        if (this.aiHelperInstance && typeof this.aiHelperInstance.startAiHelperAppearFromTheRightAimation === 'function') {
            this.aiHelperInstance.startAiHelperAppearFromTheRightAimation();
        }
    };

    onScrollStop = () => {
        this.clearScrollTimers();
        this.scrollStopTimer = setTimeout(() => {
            this.showAiHelperBall();
        }, 500);
    };

    onScroll = (e) => {
        this.hideAiHelperBall();
        this.onScrollStop();

        let scrollTop = e.nativeEvent.contentOffset.y;

        if(scrollTop > 1.5 * getScreenSize().height && !this.logedSecondScreen) {
            this.logedSecondScreen = true;
            GodEye.log({
                r: 'second_screen_show'
            })
        }

        this.setTabAnchor(scrollTop);
        this.setTabFixed(scrollTop);
    };

    setTabAnchor(scrollTop) {
        let anchor = this.props.anchor;
        for (let i = 0; i < this.points.length; i++) {
            let p = this.points[i];

            if (scrollTop >= p.y + this.cardListY - this.tabFixTop - FILTER_HEIGHT) {
                p.anchor && (anchor = p.anchor);
            }
        }

        if ((anchor !== this.props.anchor) && !this.forzenTab) {
            this.props.setAnchor(anchor);
        }
    }

    setTabFixed = (scrollTop, auto) => {
        let curFixState;

        if(auto) {
            this.setState({
                tabFixed: true
            });
            return;
        }

        if(this.cardListY < 0){
            return;
        }

        curFixState = scrollTop? scrollTop >= this.cardListY - this.tabFixTop - FILTER_HEIGHT : false;

        if (this.state.tabFixed !== curFixState) {
            this.setState({
                tabFixed: curFixState
            });
        }

    };

    navigateBack = () => {
        if (hysdk.sniff.qunar) {
            const interceptBack = getQueryParam('interceptBack');
            if (isQunarApp() && interceptBack ==='true') {
                hysdk.event.sendEvent({
                    name: 'flight-tabBar-back',
                    success: function (res) {},
                    fail: function () {
                        GodEye.log({
                            r: 'flight_tabBar_back_fail'
                        });
                    }
                });
            } else {
                hysdk.closeWebView(); 
            }
        } else {
            history.go(-1); 
        }
    }

    isHideBack = () => {
        const openSource = getQueryParam('openSource');
        return openSource === 'flightHome'
    }

    render() {
        let {
            successToast,
            loading,
            error,
            fixedSearchBoxVisible,
            userSelect,
            lowPriceDepCity,
            logData,
            isInter
        } = this.props || {};
        let appBgUri = NOTCH_PHONE ? QImageSet.notchBg : QImageSet.bg;
        let bgUri = isWxApp() ? QImageSet.wxBg : appBgUri;
        let scrollTop = this.cardListY - this.tabFixTop - FILTER_HEIGHT;
        const aiHelperParam = {
            lowPriceDepCity,
            isInter,
            ...userSelect,
            ...logData
        };

        return (
            <Provider>
                <QPopupLayerProvider>
                    <View style={styles.container}>
                        {isQunarApp() ? (()=>{
                            return <AiHelper param={aiHelperParam} />;
                        })() : null}
                        <ScrollView
                            ref={(r) => {this.scrollRef = r}}
                            onMomentumScrollEnd={this.onMomentumScrollEnd}
                            onScroll={this.onScroll}
                            scrollEventThrottle={16}
                            showsVerticalScrollIndicator={false}
                        >
                            <Image
                                resizeMode={'cover'}
                                style={[styles.bgImage, {height: NOTCH_PHONE ? getScreenSize().width / 375 * 343 : 319}]}
                                source={{uri: bgUri}}
                            />
                            <View style={styles.content}>
                                {isWxApp() ? null : (
                                    <QDNavBar
                                        mode='crystal'
                                        title={{ title: '低价榜单' }}
                                        leftButton={this.isHideBack() ?
                                            [{ icon: '', handler: () => { } }] :
                                            [{ icon: 'chevronBack', handler: this.navigateBack }]
                                        }
                                    />
                                )}
                                <SearchBox/>
                                <Filter scrollRef={this.scrollRef}/>
                                <Tab onTabPress={this.onTabPress} type='normal'/>
                                {loading && !successToast ? <Loading/> : null}
                                {
                                    error
                                        ? <View style={styles.errorField}>
                                            <Image style={styles.errorImage}
                                                   resizeMode={'contain'}
                                                   source={{uri: QImageSet.empty}}
                                            />
                                            <View style={styles.errorTipsField}>
                                                <Text style={styles.errorTips}>很抱歉，没有找到符合条件的低价机票</Text>
                                            </View>
                                        </View>
                                        : <CardSectionList
                                            scrollRef={this.scrollRef}
                                            setLayout={this.setLayout}
                                            setCardListY={this.setCardListY}/>
                                }
                            </View>
                            <View style={{height: 40, width: '100%'}} />
                        </ScrollView>
                        <GoTop scrollRef={this.scrollRef} show={this.state.tabFixed}/>
                        <View style={[styles.topFixed, this.state.tabFixed ? styles.tabFixedShow : {},fixedSearchBoxVisible ? styles.searchBoxVisible:{}]}>
                            <SearchBar tabFixed={this.state.tabFixed} scrollRef={this.scrollRef} scrollTop={scrollTop} isHideBack={this.isHideBack}/>
                            <Tab onTabPress={this.onTabPress} tabFix={this.state.tabFixed} type='topTab'/>
                            <SearchBoxWrapper tabFix={this.state.tabFixed}>
                                <SearchBox />
                            </SearchBoxWrapper>
                        </View>
                        <SearchFilter/>
                        <DepCityList/>
                        <ArrCityList/>
                        <Calendar/>
                        <SearchFilterModal scrollRef={this.scrollRef} scrollTop={scrollTop}/>
                    </View>
                </QPopupLayerProvider>
            </Provider>
        );
    }
}

@QProvider(homePage, [], true)
class HomeView extends QView {
    constructor(props) {
        super(props);
        this._mobxStore_ = new RootStore();
    }
    componentWillUnmount() {
        this._mobxStore_ = {};
    }
}
export default HomeView;

